import React from 'react';
import { Label } from '@/components/ui/label';

export const HEAR_ABOUT_OPTIONS = [
  ['google', 'Google'], ['facebook', 'Facebook'], ['instagram', 'Instagram'], ['tiktok', 'TikTok'],
  ['friend', 'Friend / word of mouth'], ['trade_show', 'Trade show / event'], ['existing_customer', 'Existing customer'], ['other', 'Other'],
];
export const HEAR_ABOUT_LABEL = Object.fromEntries(HEAR_ABOUT_OPTIONS);

/** "How did you hear about us?" dropdown shared by Add Trainee + Edit trainee details. */
export function HearAboutSelect({ value, onChange, id = 'hear-about', testid = 'trainee-hear-about' }) {
  return (
    <div>
      <Label htmlFor={id}>How did you hear about us? <span className="text-gray-400 font-normal">(optional)</span></Label>
      <select id={id} value={value || ''} onChange={(e) => onChange(e.target.value)} className="mt-1 w-full h-9 px-2 text-sm border border-gray-200 rounded-md bg-white" data-testid={testid}>
        <option value="">— Not asked —</option>
        {HEAR_ABOUT_OPTIONS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
      </select>
    </div>
  );
}
